<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="设备类型" required>
        <el-select v-model="device_type" placeholder="请选择" clearable>
          <el-option
            v-for="item in deviceCode"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备状态" required>
        <el-select v-model="status" placeholder="请选择" clearable>
          <el-option
            v-for="item in deviceStatus"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #code="{ row }">
        <div>
          {{ getNameByValue(deviceCode, row.device_type) }}
        </div>
      </template>
      <template #mec="{ row }">
        <div>
          {{ row.mechanism ? row.mechanism.mechanism_name : "待绑定" }}
        </div>
      </template>
      <template #status="{ row }">
        <el-link v-if="row.status == 0">
          {{ getNameByValue(deviceStatus, row.status)
          }}</el-link>
         <el-link v-else-if="row.status == 1" type="primary" @click="openInstall(row)">
          {{ getNameByValue(deviceStatus, row.status)
          }}<i class="el-icon-edit"></i
        ></el-link>
         <el-link type="success" v-else-if="row.status == 2">
          {{ getNameByValue(deviceStatus, row.status)
          }}</el-link>
      </template>
      <template #activ_status="{ row }">
        <div>
          {{ row.active_status ? "运行中" : "关机" }}
        </div>
      </template>
      <template #type="{ row }">
        <div>
          {{ getNameByValue(sellType, row.sell_type) }}
        </div>
      </template>
      <template #time="{ row }">
        <div>创建：{{ row.create_time || "" }}</div>
        <div>激活：{{ row.activity_time || "" }}</div>
      </template>

      <template #handler="{ row }">
        <div>
          <el-button type="success" size="small" @click="openProfit(row)"
            >设置分成</el-button
          >
          <el-button type="primary" size="small" @click="openAdd(row)"
            >添加收益</el-button
          >
        </div>
      </template>
    </auto-table>

    <setProfit ref="profitRef"></setProfit>
    <addTestCash ref="addTestRef"></addTestCash>
    <setInstall ref="installRef"></setInstall>
  </div>
</template>

<script>
import { deviceCode } from "@/views/deviceManage/components/dict";
import { deviceStatus,sellType } from "../dict";
import setProfit from "./setProfit.vue";
import addTestCash from "./addTestCash.vue";
import setInstall from "./setInstall.vue";

export default {
  components: {
    setProfit,
    addTestCash,
    setInstall,
  },
  data() {
    return {
      sellType,
      deviceStatus,
      deviceCode,
      DataList: [],
      Option: [
        { name: "序列号", value: "device_sn" },
        { name: "类型", value: "code", type: "custom" },
        { name: "门店", value: "mec", type: "custom" },
        { name: "业务状态", value: "status", type: "custom" },
        { name: "状态", value: "activ_status", type: "custom" },
        { name: "方案", value: "type", type: "custom" },
        { name: "添加时间", value: "time", type: "custom" ,width:'200px'},
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
      invest_id: "",
      device_type: "",
      status: "",
    };
  },

  mounted() {
    this.invest_id = this.$route.query.id;
  },
  methods: {
    openInstall(row) {
      if (row.status == 1) {
        this.$refs.installRef.open(row);
      }
    },
    openAdd(row) {
      this.$refs.addTestRef.open(row);
    },
    openProfit(row) {
      this.$refs.profitRef.open(row);
    },
    init() {
      if (this.DataList.length == 0) {
        this.getList(1);
      }
    },
    //获取列表
    getList(v) {
      if (!this.invest_id) {
        return;
      }
      let page = v || 1;
      this.$axios({
        url: "/user/deviceInfo/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          invest_id: this.invest_id,
          device_type: this.device_type || null,
          status: this.status || null,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>